module.exports = [{"code":"男","name":"男"},{"code":"女","name":"女"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/personSex.json
// module id = eG4O
// module chunks = 11